export enum promiseStatus {
    none = -1,
    pendding,
    reslove,
    reject
}